import React from 'react'
import { connect } from 'react-redux'
import JobAdApply from 'components/job-ad-apply'
import { mapLanguageToComponentProps } from 'careers/i18n'
import { CompanyType } from 'types'

interface JobAdApplyProps {
  company: CompanyType
}

const mapStateToProps = (state: any) => ({
  company: state.careers.company,
})

export function JobAdApplyPage(props: JobAdApplyProps) {
  return <JobAdApply {...props} />
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  JobAdApplyPage
)
